import React from 'react';
import { FieldError, FieldErrors } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

type Props = {
    className?: string;
    name: string;
    message: string;
    errors: FieldErrors;
};

/**
 * Formatted form error
 * @param {Props} props
 */
const FormError = (props: Props) => {
    return (
        <div {...props} role="alert" className={`text-danger ${props.className ?? ''}`}>
            <ErrorMessage errors={props.errors} name={props.name} message={props.message} />
        </div>
    );
};

export default FormError;
